import { authenticatedFetch } from '../../api/request';

export default async function updatePaymentMethodForOrg(orgId: number, nonce: string) {
    return authenticatedFetch(`/v5/orgs/${orgId}/setPrimaryPaymentMethod`, {
        method: 'PUT',
        body: JSON.stringify({ nonce })
    });
}
